<template>
  <base-page-layout title="Calendário promocional">
    <div class="info-message">
      <mf-icon fill>notification_important</mf-icon>
      <span>Dados referentes a campanhas recorrentes e rascunhos não estão contidos nesta página.</span>
    </div>
    <div class="calendar-grid">
      <calendario />
      <cards-resultados />
    </div>
  </base-page-layout>
</template>

<script>
export default {
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    CardsResultados: () => import('@/modules/calendario-promocional/views/pages/CalendarioPromocionalCardsResultados.vue'),
    Calendario: () => import('@/modules/calendario-promocional/views/pages/CalendarioPromocionalCalendario.vue'),
  },
}
</script>

<style lang="scss">
.info-message {
  i {
    opacity: 0.5;
    margin-bottom: 4px;
    margin-right: 4px;
  }
  span {
    opacity: 0.8;
  }
}

.calendar-grid {
  display: grid;
  grid-template-columns: 1fr 320px;
  align-items: start;
  gap: 12px;
}
</style>
